import { create } from 'zustand'

 export const useSearchStore = create((set) => ({
  title: '',
  setTitle: (title) => set({ title }),
  type: '',
  setType: (type) => set({ type }),
  date: '',
  setDate: (date) => {
    const serialisedDate = date.toISOString().split('T')[0]; 
    set({ date: serialisedDate });
  },
  
  // Reset the store
  reset: () => set({ title: '', type: '', date: '' }),
})); 